export const toPxString = (inPx: number) => `${inPx}px`;
